import { defineStore } from 'pinia'
import { useAlertStore } from './'
import { updateStoreState } from '../helpers/stateUtils'
import { normalize, schema } from 'normalizr'
import i18n from '../plugins/i18n'
import Vue from 'vue'
import {
  BEAM_API,
} from '../constants'

const channels = new schema.Entity('booking_channels')

export const useBookingChannelStore = defineStore({
  id: 'booking_channel',
  state: () => ({
    channels: [],
  }),
  getters: {
    findById: (state) => (id) => state.channels.find(find => find.id === id),
    findByIds: (state) => (ids) => state.channels.filter(find => ids.includes(find.id)),
    findAllExternal: (state) => state.channels.filter(channel => !channel.internal),
  },
  actions: {
    httpGetBookingChannels () {
      const alertStore = useAlertStore()

      return Vue.prototype.$httpEZ.get(`${BEAM_API}/booking_channels`)
        .then((response) => {
          const { entities } = normalize(response.data['hydra:member'], [channels])
          updateStoreState(this.channels, Object.values(entities.booking_channels))
        })
        .catch(() => {
          alertStore.setAlertError({ message: i18n.t('page-unit-ical-sync.actions.booking-channels.toast-error') })
        })
    },
  },
})
